// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-root-6hD {\n    margin: 0;\n}\n.image-img-rH- {\n    max-width: 100%;\n    vertical-align: middle;\n    display: inline-block;\n}\n\n@media (min-width: 48rem) {\n    .image-mobileOnly-Biq {\n        display: none;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "image-root-6hD",
	"img": "image-img-rH-",
	"mobileOnly": "image-mobileOnly-Biq"
};
export default ___CSS_LOADER_EXPORT___;
